module.exports = __webpack_public_path__ + "img/H3.b0d69e1a.png";